import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {CheckCircle, ArrowRight, Lock, ShieldCheck} from 'lucide-react';

export default function Signup() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    password: ''
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Here you would typically handle the registration logic
    alert('Cadastro simulado com sucesso! Em um ambiente real, você seria redirecionado para o checkout.');
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col md:flex-row font-sans">
      {/* Left Side - Info */}
      <div className="w-full md:w-1/2 bg-blue-900 text-white p-8 md:p-12 flex flex-col justify-between relative overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://images.pexels.com/photos/3184339/pexels-photo-3184339.jpeg?auto=compress&cs=tinysrgb&w=1600')] bg-cover bg-center opacity-10 mix-blend-overlay"></div>
        
        <div className="relative z-10">
          <Link to="/" className="inline-block mb-12">
            <img 
              src="https://ewpass.com.br/wp-content/uploads/2022/10/EW-Pass-Logo-Colorida-Fundo-Transparente-Site.png" 
              alt="EW Pass Logo" 
              className="h-10 brightness-0 invert"
            />
          </Link>
          
          <h1 className="text-3xl md:text-4xl font-bold mb-6">
            Você está a um passo de <span className="text-blue-300">transformar seu inglês</span>
          </h1>
          
          <div className="space-y-6 mt-8">
            <div className="flex items-start gap-4">
              <div className="bg-blue-800 p-2 rounded-full">
                <CheckCircle className="text-green-400" size={24} />
              </div>
              <div>
                <h3 className="font-bold text-lg">7 Dias Grátis</h3>
                <p className="text-blue-200 text-sm">Acesso total sem pagar nada hoje. Cancele quando quiser.</p>
              </div>
            </div>
            
            <div className="flex items-start gap-4">
              <div className="bg-blue-800 p-2 rounded-full">
                <CheckCircle className="text-green-400" size={24} />
              </div>
              <div>
                <h3 className="font-bold text-lg">Tutora Lucy IA 24h</h3>
                <p className="text-blue-200 text-sm">Tire dúvidas e pratique conversação a qualquer hora no WhatsApp.</p>
              </div>
            </div>
            
            <div className="flex items-start gap-4">
              <div className="bg-blue-800 p-2 rounded-full">
                <CheckCircle className="text-green-400" size={24} />
              </div>
              <div>
                <h3 className="font-bold text-lg">Certificados Inclusos</h3>
                <p className="text-blue-200 text-sm">Receba certificado a cada nível concluído.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="relative z-10 mt-12 pt-8 border-t border-blue-800">
          <div className="flex items-center gap-2 text-blue-300 text-sm">
            <ShieldCheck size={16} />
            <span>Ambiente seguro e criptografado</span>
          </div>
          <p className="text-xs text-blue-400 mt-2">
            Ao se cadastrar, você concorda com nossos Termos de Uso e Política de Privacidade.
          </p>
        </div>
      </div>

      {/* Right Side - Form */}
      <div className="w-full md:w-1/2 p-8 md:p-12 flex items-center justify-center bg-white">
        <div className="max-w-md w-full">
          <div className="text-center mb-8 md:hidden">
             <img 
              src="https://ewpass.com.br/wp-content/uploads/2022/10/EW-Pass-Logo-Colorida-Fundo-Transparente-Site.png" 
              alt="EW Pass Logo" 
              className="h-10 mx-auto"
            />
          </div>
          
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Crie sua conta</h2>
          <p className="text-gray-600 mb-8">Preencha seus dados para liberar seu acesso gratuito.</p>
          
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">Nome Completo</label>
              <input
                type="text"
                id="name"
                name="name"
                required
                value={formData.name}
                onChange={handleChange}
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all outline-none"
                placeholder="Seu nome"
              />
            </div>
            
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">E-mail</label>
              <input
                type="email"
                id="email"
                name="email"
                required
                value={formData.email}
                onChange={handleChange}
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all outline-none"
                placeholder="seu@email.com"
              />
            </div>
            
            <div>
              <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">WhatsApp</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                required
                value={formData.phone}
                onChange={handleChange}
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all outline-none"
                placeholder="(00) 00000-0000"
              />
            </div>

            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">Senha</label>
              <input
                type="password"
                id="password"
                name="password"
                required
                value={formData.password}
                onChange={handleChange}
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all outline-none"
                placeholder="Crie uma senha segura"
              />
            </div>
            
            <div className="pt-4">
              <button
                type="submit"
                className="w-full bg-green-500 hover:bg-green-600 text-white font-bold py-4 px-8 rounded-lg shadow-lg transition-all transform hover:-translate-y-1 flex items-center justify-center gap-2"
              >
                LIBERAR ACESSO GRÁTIS <ArrowRight size={20} />
              </button>
              <p className="text-center text-xs text-gray-500 mt-4 flex items-center justify-center gap-1">
                <Lock size={12} /> Seus dados estão 100% seguros
              </p>
            </div>
          </form>
          
          <div className="mt-8 pt-8 border-t border-gray-100 text-center">
            <p className="text-gray-600">Já tem uma conta? <a href="#" className="text-blue-600 font-bold hover:underline">Fazer Login</a></p>
          </div>
        </div>
      </div>
    </div>
  );
}